module.exports = __webpack_public_path__ + "static/img/a202.9dd0994c.png";